import React, { useState, useEffect, useRef  } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useParams } from "react-router-dom";
import BlurText from "./comp/BlurText";
import { Filesystem, Directory } from '@capacitor/filesystem';
import LiquidEther from "./comp/Galaxy";
// LogoLoop removed — using a sticky footer for socials instead
import AudioPlayer from "./comp/AudioPlayer";
import { gsap } from "gsap";
import VideoPlayer from "./comp/VideoPlayer";

import CountUp from './CountUp'
import {
  SiReact,
  SiNextdotjs,
  SiTypescript,
  SiTailwindcss,
  SiDiscord,
  SiTwitch,
  SiTelegram,
  SiYoutube
} from "react-icons/si";
import { FiCopy, FiDownload } from 'react-icons/fi';

import ConfirmModal from "./comp/ConfirmModal";
import Toast from "./comp/Toast";
import Button from "./comp/Button"; // import the styled button
import B from "./comp/b"; // import the styled button
import BA from "./comp/ba"; // import the styled button
import SplashCursor from './comp/SplashCursor'
import ProfileCard from './comp/ProfileCard'
import Orb from './comp/Orb';
const API_URL = "https://yurinkov.dev";
import SplitText from "./SplitText";
import DarkVeil from './DarkVeil';
import FadeContent from './FadeContent'
import AnimatedContent from './AnimatedContent'
import RotatingText from './RotatingText'
import { LayoutGroup, motion } from 'motion/react';
import Navbar from './components/Navbar';
import ChatPage from './pages/ChatPage';
import KtoPage from './pages/KtoPage';
import KtoksazalPage from './pages/KtoksazalPage';
const techLogos = [
  { node: <SiDiscord />, title: "Discord", href: "https://discord.com/users/452385344898465793" },
  { node: <SiTwitch />, title: "Twitch", href: "https://twitch.tv/yurinkovich" },
  { node: <SiTelegram />, title: "Telegram", href: "https://t.me/Yurinkovich" },
  { node: <SiYoutube />, title: "YouTube", href: "https://www.youtube.com/@JurijusXas/videos" }
];

const downloadFile = async (url, fileName, setToast) => {
  try {
    // Fetch the file
    const response = await fetch(url);
    const blob = await response.blob();
    const base64Data = await blobToBase64(blob);

    // Write the file to app's Documents directory
    await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents,
      recursive: true
    });

    setToast && setToast({ open: true, message: `Файл ${fileName} сохранён!` });
  } catch (err) {
    console.error(err);
    setToast && setToast({ open: true, message: `Ошибка при сохранении ${fileName}` });
  }
};

// Helper to convert blob to base64
const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.readAsDataURL(blob);
  });


// 🔹 Helper to detect file type
const getFileType = (file) => {
  if (!file || !file.name) return "other";
  const ext = file.name.split('.').pop().toLowerCase();
  if (["png","jpg","jpeg","gif","webp"].includes(ext)) return "image";
  if (["mp4","webm","ogg"].includes(ext)) return "video";
  if (["mp3","wav","ogg"].includes(ext)) return "audio";
  if (["zip","rar","tar","7z"].includes(ext)) return "archive";
  return "other";
};

// Fix mojibake when UTF-8 bytes were misinterpreted as Latin1
const fixEncoding = (str) => {
  if (!str || typeof str !== 'string') return str;
  try {
    // decodeURIComponent(escape(...)) recovers UTF-8 from latin1-encoded strings
    // eslint-disable-next-line no-undef
    return decodeURIComponent(escape(str));
  } catch (e) {
    return str;
  }
};

// 🔹 Upload Page
const UploadPage = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [isNSFW, setIsNSFW] = useState(false);
  useEffect(() => { if (file) uploadFile(file); }, [file]);

  useEffect(() => {
    const handlePaste = (e) => { if (e.clipboardData.files[0]) setFile(e.clipboardData.files[0]); };
    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  const uploadFile = (fileToUpload) => {
    setUploading(true);
    setProgress(0);
    const formData = new FormData();
    formData.append("file", fileToUpload);
    formData.append("nsfw", isNSFW);
    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = (e) => { if (e.lengthComputable) setProgress(Math.floor((e.loaded / e.total) * 100)); };
    xhr.onload = () => { const fileData = JSON.parse(xhr.response); setUploading(false); navigate(`/view/${fileData.id}`); };
    xhr.onerror = () => { alert("Ошибка загрузки"); setUploading(false); };
    xhr.open("POST", `${API_URL}/api/upload`);
    xhr.send(formData);
    
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 relative text-white">
{/* Admin Panel Button */}
<button
  onClick={() => navigate("/admin-login")}
  className="fixed top-8 right-8 w-14 h-14 rounded-full bg-black hover:bg-gray-900 text-white flex items-center justify-center shadow-lg transition-all duration-300 text-sm font-semibold"
  title="Admin Panel"
>
  Admin
</button>

<LayoutGroup>
  <motion.p className="flex items-center gap-2 text-6xl font-extrabold tracking-tight -mt-12 md:-mt-16 lg:-mt-20 mb-12 md:mb-16 lg:mb-20 z-20" layout>
    <motion.span layout transition={{ type: 'spring', damping: 30, stiffness: 400 }} className="">
      Yurinkovich
    </motion.span>
      <RotatingText
      texts={[
  'online',
  'онлайн',
  'топ',
  'лучший',
  'гений',
  'крутой',
  'лев',
  'тигр',
  'пикми',
  'boss',
  'чемпион',
  'легенда',
  'мощный',
  'экстраординарный',
  'имба',
  'лютая имба',
  'машина',
  'монстр',
  'сигма',
  'alpha',
  'ультра',
  'база',
  'абсолют',
  'чел',
  'бро',
  'краш',
  'рофл',
  'кринж',
  'шиза',
  'неиронично',
  'балбес',
  'бубенчик',
  'крякозябра',
  'шмяк',
  'пузырёк',
  'хрюндель',
  'чмоня',
  'булочка',
  'котик',
  'витязь',
  'удалец',
  'чародей',
  'богатырь'
]}
               mainClassName="px-3 sm:px-3 md:px-4 overflow-hidden py-1 sm:py-1 md:py-2 justify-center rounded-lg bg-gradient-to-r from-indigo-500/75 via-purple-500/75 to-pink-500/75 text-white shadow-lg"
     staggerFrom={"last"}
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "-120%" }}
      staggerDuration={0.025}
      splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
      transition={{ type: "spring", damping: 30, stiffness: 400 }}
      rotationInterval={2000}
    />
  </motion.p>
</LayoutGroup>
<AnimatedContent
  distance={10}
  direction="vertical"
  reverse={false}
  duration={1}
  ease="ease.out"
  initialOpacity={0.5}
  animateOpacity
  scale={1}
  threshold={0.1}
  delay={0.7}
>
      <div className="w-full max-w-2xl bg-gradient-to-br from-black/60 to-black/40 backdrop-blur-md border border-white/10 rounded-3xl p-8 shadow-2xl flex flex-col gap-6 transition-transform duration-500 hover:scale-105 relative">
        <div className="flex justify-between items-center mb-2">
          <h1 className="text-4xl font-extrabold tracking-tight">📤 Загрузить файл</h1>
          <button
            onClick={() => navigate("/history")}
            className="bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-full shadow-md transition ml-8 md:ml-12"
            aria-label="История"
          >
            История
          </button>
        </div>

        <div className="flex flex-col items-center w-full">
          <label
            onDrop={(e) => { e.preventDefault(); if (e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]); }}
            onDragOver={(e) => e.preventDefault()}
            className="w-full flex flex-col items-center justify-center border-2 border-dashed border-white/10 bg-white/5 hover:bg-white/3 rounded-xl p-6 cursor-pointer transition"
          >
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              className="hidden"
            />
            <div className="text-center">
              <p className="text-sm text-gray-300">Перетащите файл сюда или нажмите кнопку</p>
              {file && <p className="mt-2 text-white font-medium truncate max-w-full">{fixEncoding(file.name)}</p>}
              <div className="mt-4">
                <span className="inline-block bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-md">Выбрать файл</span>
              </div>
            </div>
          </label>

          <label className="flex items-center gap-2 text-gray-300 mt-4 cursor-pointer">
            <input
              type="checkbox"
              checked={isNSFW}
              onChange={(e) => setIsNSFW(e.target.checked)}
              className="w-4 h-4 accent-red-500"
            />
            <span>Отметить как НЕ ДЛЯ СТРИМА 🔞</span>
          </label>

          {uploading && (
            <div className="w-full bg-gray-700 rounded-full h-3 overflow-hidden mb-4 mt-4">
              <div className="h-full bg-indigo-500 transition-all duration-300" style={{ width: `${progress}%` }} />
            </div>
          )}


        </div>
      </div>
    </AnimatedContent>
    </div>
  );
};

// 🔹 File Viewer
const FileViewer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [toastOpen, setToastOpen] = useState(false);
  const [showNSFW, setShowNSFW] = useState(false); // ✅ here
  const blurRef = useRef(null); // ✅ here
const formatDate = (dateString) => {
  const d = new Date(dateString);
  const pad = (n) => n.toString().padStart(2, '0');

  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1); // months are 0-indexed
  const day = pad(d.getDate());
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  const seconds = pad(d.getSeconds());


  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};
  useEffect(() => {
    fetch(`${API_URL}/api/file/${id}`)
      .then(res => { if (!res.ok) throw new Error("File not found"); return res.json(); })
      .then(setFile)
      .catch(err => console.error(err));
  }, [id]);

  if (!file)
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-white">
        <AnimatedContent
  distance={150}
  direction="vertical"
  reverse={false}
  duration={1}
  ease="power3.out"
  initialOpacity={0}
  animateOpacity
  scale={5}
  threshold={0.1}
  delay={0.7}
>
        <div className="bg-black/50 backdrop-blur-md border border-white/10 rounded-xl p-6 text-center">
          <p className="mb-4">Файл не найден.</p>
          <button
            onClick={() => navigate("/")}
            className="mt-2 bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded"
          >
            Назад
          </button>
        </div></AnimatedContent>
      </div>
      
    );

  const fileType = getFileType(file);
  const fileUrl = `${API_URL}${file.url}`;
  const downloadUrl = `${API_URL}/api/download/${file.id}`;

    // Copy the raw source when possible; otherwise copy the source URL.
    const copySource = async () => {
      try {
        const res = await fetch(fileUrl);
        const contentType = (res.headers.get("content-type") || "").toLowerCase();

        if (contentType.startsWith("text") || contentType.includes("json") || contentType.includes("xml")) {
          const text = await res.text();
          await navigator.clipboard.writeText(text);
          setToastOpen(true);
        } else {
          // For binary media, copy the direct URL instead
          await navigator.clipboard.writeText(fileUrl);
          setToastOpen(true);
        }
      } catch (err) {
        console.error(err);
        try { await navigator.clipboard.writeText(fileUrl); setToastOpen(true); } catch {};
      }
    };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 text-white relative">
      <AnimatedContent
  distance={150}
  direction="vertical"
  reverse={false}
  duration={1}
  ease="power3.out"
  initialOpacity={0.2}
  animateOpacity
  scale={1}
  threshold={0.2}
  delay={0.1}
>
  <LayoutGroup>
    <motion.div className="w-full flex justify-center mb-8" layout>
      <motion.p className="flex items-center gap-2 text-6xl font-extrabold tracking-tight" layout>
        <motion.span layout transition={{ type: 'spring', damping: 30, stiffness: 400 }}>
          Yurinkovich
        </motion.span>
        <RotatingText
      texts={[
  'online',
  'онлайн',
  'топ',
  'лучший',
  'гений',
  'крутой',
  'лев',
  'тигр',
  'пикми',
  'boss',
  'чемпион',
  'легенда',
  'мощный',
  'экстраординарный',
  'имба',
  'лютая имба',
  'машина',
  'монстр',
  'сигма',
  'alpha',
  'ультра',
  'база',
  'абсолют',
  'чел',
  'бро',
  'краш',
  'рофл',
  'кринж',
  'шиза',
  'неиронично',
  'балбес',
  'бубенчик',
  'крякозябра',
  'шмяк',
  'пузырёк',
  'хрюндель',
  'чмоня',
  'булочка',
  'котик',
  'витязь',
  'удалец',
  'чародей',
  'богатырь'
]}
          mainClassName="inline-flex items-center justify-center px-3 sm:px-3 md:px-4 py-1 sm:py-1 md:py-2 rounded-lg bg-gradient-to-r from-indigo-500/75 via-purple-500/75 to-pink-500/75 text-white shadow-lg w-[220px] md:w-[300px] max-w-[340px] overflow-hidden whitespace-nowrap truncate text-center flex-shrink-0"
          staggerFrom={"last"}
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "-120%" }}
          staggerDuration={0.02}
          splitLevelClassName="overflow-hidden"
          transition={{ type: "spring", damping: 30, stiffness: 300 }}
          rotationInterval={2200}
        />
      </motion.p>
    </motion.div>
  </LayoutGroup>
      <div className="w-full max-w-6xl bg-gradient-to-br from-black/30 via-black/50 to-black/80 backdrop-blur-xl border border-white/8 rounded-3xl p-8 shadow-lg relative transition-transform">
        <button
          onClick={() => navigate("/")}
          className="absolute left-4 top-6 z-40 bg-transparent hover:bg-white/5 text-white px-3 py-1 rounded-md flex items-center gap-2"
          aria-label="Назад"
        >
          {"<-- Назад"}
        </button>


      <div className="mb-6 mt-6 flex justify-center items-center overflow-visible relative">
  {/* 🔞 NSFW wrapper */}
  {file?.nsfw && !showNSFW && (
    <div
      ref={blurRef}
      className="absolute inset-0 flex flex-col items-center justify-center backdrop-blur-3xl bg-black/70 text-center rounded-md"
      style={{ zIndex: 20 }}
    >
      <p className="text-lg text-red-400 font-semibold mb-4">⚠️ Контент НЕ ДЛЯ СТРИМА</p>
      <div className="flex gap-4">
        <button
          onClick={() => {
            gsap.to(blurRef.current, {
              opacity: 0,
              duration: 0.6,
              ease: "power2.out",
              onComplete: () => setShowNSFW(true),
            });
          }}
          className="bg-green-600 hover:bg-green-500 text-white px-6 py-2 rounded-lg font-semibold transition"
        >
          Смотреть
        </button>
        <button
          onClick={() => navigate("/")}
          className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-2 rounded-lg font-semibold transition"
        >
          Назад
        </button>
      </div>
    </div>
  )}

  {/* 📸 Regular media rendering */}
  {fileType === "image" && (
    <img
      src={fileUrl}
      alt={fixEncoding(file.name)}
      className={`rounded-md max-h-[80vh] w-auto object-contain transition-all duration-700 ${
        file?.nsfw && !showNSFW ? "blur-3xl" : "blur-0"
      }`}
    />
  )}

  {fileType === "video" && (
    <div className={`transition-all duration-700 ${file?.nsfw && !showNSFW ? "blur-3xl" : "blur-0"}`}>
      <VideoPlayer src={fileUrl} title={fixEncoding(file.name)} />
    </div>
  )}

  {fileType === "audio" && (
    <div className="w-full flex justify-center">
      <AudioPlayer src={fileUrl} title={fixEncoding(file.name)} />
    </div>
  )}

  {(fileType === "archive" || fileType === "other") && (
    <div className="flex justify-center items-center w-full h-48 border border-white/20 rounded-md text-gray-300">
      📄 Файл не поддерживается для просмотра
    </div>
  )}
</div>

{/* File info below media */}
<div className="mt-3 text-left text-gray-300 text-sm">
  <p className="font-medium">{fixEncoding(file.name)} {formatDate(file.uploadedAt)}</p>
</div>
        <div className="flex flex-wrap gap-3 justify-center mt-2">
          <button
            title="Копировать ссылку"
            onClick={() => {
              const shareUrl = `https://yurinkov.dev/view/${file.id}`;
              navigator.clipboard.writeText(shareUrl);
              setToastOpen(true);
            }}
            className="bg-indigo-600 hover:bg-indigo-500 text-white px-6 py-2 rounded-full shadow-md transition min-w-[96px] text-center"
          >
            Копировать ссылку
          </button>

          <button
            onClick={copySource}
            title="Копировать источник (текст или URL)"
            className="bg-slate-800 hover:bg-slate-700 text-white px-4 py-2 rounded-full shadow-sm transition min-w-[96px] text-center"
          >
            Копировать источник
          </button>

          <button
            title="Скачать"
            onClick={() => {
                if (Capacitor.getPlatform() === "android" || Capacitor.getPlatform() === "ios") {
                downloadFile(downloadUrl, fixEncoding(file.name), setToastOpen);
              } else {
                // Default web download
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = fixEncoding(file.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }}
            className="bg-indigo-600 hover:bg-indigo-500 text-white px-3 py-2 rounded-full shadow-md transition flex items-center justify-center min-w-[44px] h-10"
            aria-label="Скачать"
          >
            <FiDownload className="text-lg" />
          </button>

        </div>

        <Toast isOpen={toastOpen} message="Ссылка скопирована!" onClose={() => setToastOpen(false)} />
      </div></AnimatedContent>
      
    </div>
  );
};
// 🔹 User History
const HistoryPage = () => {
  const [uploads, setUploads] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
const formatDate = (dateString) => {
  const d = new Date(dateString);
  const pad = (n) => n.toString().padStart(2, '0');

  const year = d.getFullYear();
  const month = pad(d.getMonth() + 1); // months are 0-indexed
  const day = pad(d.getDate());
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  const seconds = pad(d.getSeconds());

  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};
  useEffect(() => { fetch(`${API_URL}/api/history`).then(res => res.json()).then(setUploads); }, []);

  const handleDeleteClick = file => { setSelectedFile(file); setModalOpen(true); };
  const confirmDelete = () => { fetch(`${API_URL}/api/delete/${selectedFile.id}`, { method: "DELETE" }).then(() => { setUploads(uploads.filter(f => f.id !== selectedFile.id)); setModalOpen(false); setSelectedFile(null); }).catch(console.error); };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 text-white relative">
        <SplitText
  text="yurinkov.dev"
  className="text-6xl mb-12 text-center"
  delay={70}
  duration={0.4}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 40 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="-100px"
  textAlign="center"
/>
      {uploads.length === 0 ? <p className="text-center text-gray-300">Нет загруженных файлов.</p> : (
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {uploads.map(file => {
            const fileType = getFileType(file);
            return (
              <div key={file.id} className="p-4 rounded-lg border border-white/10 bg-black/40 hover:bg-black/50 transition group">
                <div className="mb-2 h-32 flex justify-center items-center overflow-hidden">
                  {fileType === "image" && <img src={`${API_URL}${file.url}`} className="max-h-full object-contain" />}
                  {fileType === "video" && <video src={`${API_URL}${file.url}`} className="max-h-full object-contain" />}
                </div>
                <p className="font-medium text-white truncate cursor-pointer" onClick={() => navigate(`/view/${file.id}`)}>{fixEncoding(file.name)}</p>
<p className="text-sm text-gray-400">{formatDate(file.uploadedAt)}</p>

                <div className="mt-2 flex justify-between">
                  <button onClick={() => navigate(`/view/${file.id}`)} className="text-indigo-400 hover:text-indigo-300 text-sm">Просмотр</button>
                  <button onClick={() => handleDeleteClick(file)} className="text-red-400 hover:text-red-300 text-sm">Удалить</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="mt-6 text-center">
        <button onClick={() => navigate("/")} className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md">Назад</button>
      </div>

      <ConfirmModal isOpen={modalOpen} title="Подтвердите удаление" message={`Вы уверены, что хотите удалить "${selectedFile?.name}"?`} onConfirm={confirmDelete} onCancel={() => setModalOpen(false)} />
    </div>
  );
};

// 🔹 Admin Login
const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [blocked, setBlocked] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");

  const login = async () => {
    if (blocked) return;

    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });

      if (res.status === 200) {
        const data = await res.json();
        localStorage.setItem("adminToken", data.token);
        navigate("/admin");
      } else if (res.status === 401) {
        setAttempts(prev => prev + 1);
        setError(`Неверный пароль. Попытка ${attempts + 1} из 3.`);
      } else if (res.status === 403) {
        const data = await res.json();
        setBlocked(true);
        setBlockedMessage(data.message);
      } else {
        setError("Произошла ошибка входа.");
      }
    } catch (err) {
      setError("Ошибка соединения с сервером.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-white bg-black/80">
      <div className="bg-black/60 backdrop-blur-md border border-white/10 rounded-2xl p-8 shadow-lg w-full max-w-sm">
        <h1 className="text-2xl font-semibold mb-4 text-center">Вход администратора</h1>
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 rounded mb-4 bg-gray-800 text-white border border-gray-700"
          disabled={blocked}
        />
        {error && <p className="text-red-500 mb-2">{error}</p>}
        {blocked && <p className="text-red-500 mb-2 font-semibold">{blockedMessage}</p>}
        <button
          onClick={login}
          className={`w-full py-2 rounded text-white ${
            blocked ? "bg-gray-600 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700"
          }`}
          disabled={blocked}
        >
          Войти
        </button>
      </div>
    </div>
  );
};
const AdminPage = () => {
  const navigate = useNavigate();
  const [uploads, setUploads] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [allConfirmOpen, setAllConfirmOpen] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("admin-token") || "");
  const [password, setPassword] = useState("");
  const [toast, setToast] = useState({ open: false, message: "" });

  // Login
  const handleLogin = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) throw new Error("Неверный пароль");
      const data = await res.json();
      setToken(data.token);
      localStorage.setItem("admin-token", data.token);
      fetchUploads(data.token);
    } catch (err) {
      alert(err.message);
    }
  };

  // Fetch all uploads
  const fetchUploads = async (authToken = token) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/uploads`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      if (!res.ok) throw new Error("Ошибка загрузки файлов");
      const data = await res.json();
      setUploads(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (token) fetchUploads();
  }, [token]);

  const handleDeleteClick = (file) => {
    setSelectedFile(file);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await fetch(`${API_URL}/api/delete/${selectedFile.id}`, { method: "DELETE" });
      setUploads(uploads.filter(f => f.id !== selectedFile.id));
      setSelectedFile(null);
      setModalOpen(false);
      setToast({ open: true, message: "Файл удалён" });
    } catch (err) {
      console.error(err);
    }
  };

  const confirmDeleteAll = async () => {
    try {
      await fetch(`${API_URL}/api/delete-all`, { method: "DELETE" });
      setUploads([]);
      setAllConfirmOpen(false);
      setToast({ open: true, message: "Все файлы удалены" });
    } catch (err) {
      console.error(err);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-white">
        <div className="bg-black/50 backdrop-blur-md border border-white/10 rounded-xl p-8 w-full max-w-sm">
          <h2 className="text-2xl mb-4 text-center">Админ вход</h2>
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 rounded mb-4 bg-gray-800 text-white border border-gray-700"
          />
          <button
            onClick={handleLogin}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded"
          >
            Войти
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6 text-white">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Админ: все файлы</h1>
        <button
          onClick={() => setAllConfirmOpen(true)}
          className="bg-red-600 hover:bg-red-500 px-4 py-2 rounded"
        >
          Удалить все
        </button>
        <button
  onClick={() => navigate("/")}
  className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md mb-4"
>
  ← Main Page
</button>

      </div>

      {uploads.length === 0 ? (
        <p className="text-center text-gray-300">Нет загруженных файлов</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {uploads.map((file) => {
            const fileType = getFileType(file);
            const url = `${API_URL}${file.url}`;
            return (
              <div key={file.id} className="p-4 rounded-lg border border-white/10 bg-black/40 hover:bg-black/50 transition group">
                <div className="mb-2 h-32 flex justify-center items-center overflow-hidden">
                  {fileType === "image" && <img src={url} alt="" className="max-h-full object-contain" />}
                  {fileType === "video" && <video src={url} className="max-h-full" />}
                  {fileType === "audio" && <div className="text-sm">Аудио</div>}
                  {(fileType === "archive" || fileType === "other") && <div className="text-sm">Файл</div>}
                </div>
                <p className="truncate">{fixEncoding(file.name)}</p>
                <p className="text-xs text-gray-400">{file.ip}</p>
                <p className="text-xs text-gray-400">{new Date(file.uploadedAt).toLocaleString()}</p>
                <div className="mt-2 flex justify-end items-center gap-4">
                  <button onClick={() => navigate(`/view/${file.id}`)} className="text-indigo-400 hover:text-indigo-300 text-sm">Просмотр</button>
                  <button onClick={() => handleDeleteClick(file)} className="text-red-400 hover:text-red-300 text-sm">Удалить</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <ConfirmModal
        isOpen={modalOpen}
        title="Подтвердите удаление"
        message={`Вы уверены, что хотите удалить "${selectedFile?.name}"?`}
        onConfirm={confirmDelete}
        onCancel={() => setModalOpen(false)}
      />

      <ConfirmModal
        isOpen={allConfirmOpen}
        title="Подтвердите удаление всех файлов"
        message="Вы уверены, что хотите удалить все файлы?"
        onConfirm={confirmDeleteAll}
        onCancel={() => setAllConfirmOpen(false)}
      />

      <Toast isOpen={toast.open} message={toast.message} onClose={() => setToast({ ...toast, open: false })} />
    </div>
  );
};


// 🔹 Main App
const App = () => {
  const [uploadCount, setUploadCount] = useState(0);

  useEffect(() => {
    let mounted = true;

    const loadCount = async () => {
      try {
        const res = await fetch('/upload_logs.json', { cache: 'no-store' });
        if (!res.ok) throw new Error(`status ${res.status}`);
        const data = await res.json();
        if (!mounted) return;
        if (Array.isArray(data)) {
          setUploadCount(new Set(data.map(d => d.id)).size);
          return;
        }
        if (data && typeof data === 'object') {
          if (Array.isArray(data.uploads)) {
            setUploadCount(new Set(data.uploads.map(d => d.id)).size);
            return;
          }
          setUploadCount(Object.keys(data).length);
          return;
        }
      } catch (err) {
        console.error('Failed to fetch /upload_logs.json:', err);
      }
    };

    loadCount();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="relative min-h-screen overflow-auto bg-black">
    {/* Background layer */}
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "black",
        zIndex: 0, // ✅ not negative!
      }}
    />

    {/* Optional overlay (DarkVeil) */}
    <div style={{ position: "fixed", inset: 0, zIndex: 1 }}>
      <DarkVeil topColor="#ff0000"
    bottomColor="#566cff"
    intensity={1.0}
    rotationSpeed={0.5}
    glowAmount={0.005}
    pillarWidth={3.0}
    pillarHeight={0.4}
    noiseIntensity={0.5}
    pillarRotation={45}
    interactive={false}
    mixBlendMode="normal"
  />
    </div>

    {/* Main content */}
    <div className="relative z-10">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<UploadPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/kto" element={<KtoPage />} />
          <Route path="/ktoskazal" element={<KtoksazalPage />} />
          <Route path="/view/:id" element={<FileViewer />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Router>
    </div>

  <footer className="fixed left-0 right-0 bottom-0 bg-black/70 backdrop-blur-md border-t border-white/10 text-white z-40">
    <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
      <div className="text-sm opacity-90">© {new Date().getFullYear()} Yurinkovich</div>

      <div className="text-sm opacity-90 flex items-center gap-3">
        <span>файлов загруженно:</span>
        <CountUp from={0} to={uploadCount} separator="," direction="up" duration={1} className="count-up-text" />
      </div>

      <div className="flex items-center gap-3">
        {techLogos.map((t, i) => (
          <a
            key={i}
            href={t.href}
            title={t.title}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 rounded hover:bg-white/10 transition"
          >
            <span className="text-xl">{t.node}</span>
          </a>
        ))}
      </div>
    </div>
  </footer>
  </div>
  );
};


export default App;
